import axios, { AxiosResponse } from 'axios'

/**
 * @description service to update user
 * @param userId
 */
const updateUser = async (
  userId: number,
  personId: number,
  firstName: string,
  lastName: string,
  document: number,
  email: string,
  companyId?: number
) => {
  const PATH = `/company/user/${userId}`

  const body = {
    personId,
    firstName,
    lastName,
    document,
    email,
    companyId,
  }

  try {
    const response: AxiosResponse = await axios.put(PATH, body)

    return response
  } catch (error: any) {
    console.error('error on get process by company', error)
    const message = error?.response?.data?.message

    if (message === 'Email or document already exists') {
      return 'Email or document already exists'
    }

    return {
      error: true,
      message: message || 'An unexpected error occurred while updating the user',
      status: error?.response?.status,
    }
  }
}

export default updateUser
